/**
 * PRD-018 §3.5, Q1 decided by Sean 2026-09-11: the page a person lands on after sign-in, after MFA enrollment,
 * and at `/`. One constant so the router, the sign-in page, the Google callback and the enroll page cannot drift.
 * Home is the landing; My work stays one chord away (`g m`). PRD-016 §8.0 said Home from the start.
 */
export const LANDING = '/home'

/**
 * Where to send a person once they are signed in: back to the protected page they were trying to open
 * (a deep link the shell bounced to /signin, PRD-018 §3.13), otherwise the landing. Only same-origin paths
 * count, so a `from` that came in through history state can never send the browser off-site.
 */
export function afterSignIn(from: string | undefined | null): string {
  if (typeof from === 'string' && from.startsWith('/') && !from.startsWith('//'))
    return from
  return LANDING
}
